import { useContext, useEffect, useState } from "react";
import styles from "./main.module.scss";
import { Drawer } from "@mui/material";
import ModifiedSidebar from "./sideBar/modifiedSidebar";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "./header/header";
import { isCurrentDateGreaterThan } from "../../utils/dateUtils";
import { userAtom } from "../../utils/store";
import { useAtom } from "jotai";
import { NotificationContext } from "../../provider/notification";
import { logout } from "../../utils/logout";

const drawerWidth = 280;
const smallDrawerWidth = 250;
const backgroundColor = "#335642";
const zeroIndex = 0;

// interface ComponentProps {
//     children: React.ReactNode;
// }
interface Props {
  window?: () => Window;
}

const Main: React.FC<Props> = ({ window }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [user, setUser] = useAtom(userAtom);

  const handleSidebarToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  if (isCurrentDateGreaterThan(user?.expiryDate)) {
    logout();
  }

  return (
    <div className={styles.container}>
      <Header handleSidebarToggle={handleSidebarToggle} />

      <Drawer
        className={styles.sideBar}
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: smallDrawerWidth,
            backgroundColor: backgroundColor,
            zIndex: zeroIndex,
          },
        }}
      >
        <ModifiedSidebar />
      </Drawer>

      <Drawer
        container={container}
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            backgroundColor: backgroundColor,
            zIndex: zeroIndex,
          },
        }}
        open
      >
        <ModifiedSidebar />
      </Drawer>

      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default Main;
